import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Analytics as AnalyticsIcon,
  LocationOn as LocationOnIcon,
  Schedule as ScheduleIcon,
  Group as GroupIcon,
} from '@mui/icons-material';
import { useAlbum } from '../../contexts/AlbumContext';
import { useApi } from '../../hooks/useApi';

const ProcessingStep = () => {
  const { uploadedFiles, loading } = useAlbum();
  const { processPhotos } = useApi();

  const features = [
    {
      icon: <ScheduleIcon color="primary" />,
      primary: 'EXIF 메타데이터 추출',
      secondary: '촬영 시간, GPS 좌표 분석',
    },
    {
      icon: <GroupIcon color="primary" />,
      primary: '시간/위치 기반 자동 그룹화',
      secondary: '비슷한 시간대의 사진을 묶음',
    },
    {
      icon: <LocationOnIcon color="primary" />,
      primary: 'GPS 좌표로 장소명 식별',
      secondary: '주변 명소 자동 추천',
    },
  ];

  return (
    <Stack spacing={3}>
      <Card>
        <CardContent sx={{ textAlign: 'center', py: 3 }}>
          <AnalyticsIcon
            sx={{ fontSize: 64, color: 'primary.main', mb: 2 }}
          />
          <Typography variant="h2" gutterBottom>
            사진 분석
          </Typography>
          <Typography variant="body2" color="text.secondary">
            업로드된 <strong>{uploadedFiles.length}장</strong>의 사진을 분석합니다.
          </Typography>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            분석 내용
          </Typography>
          <List disablePadding>
            {features.map((feature, index) => (
              <React.Fragment key={index}>
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    {feature.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={feature.primary}
                    secondary={feature.secondary}
                    primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                    secondaryTypographyProps={{ variant: 'caption' }}
                  />
                  <CheckCircleIcon color="disabled" fontSize="small" />
                </ListItem>
                {index < features.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </CardContent>
      </Card>

      <Button
        variant="contained"
        size="large"
        onClick={processPhotos}
        disabled={loading}
        fullWidth
        sx={{ py: 1.5 }}
      >
        {loading ? '분석 중...' : '사진 분석 시작'}
      </Button>
    </Stack>
  );
};

export default ProcessingStep;
